import React, { useState } from 'react';
import { resolvePath, useLocation, useResolvedPath } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Link } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import classnames from 'classnames';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { isLocationMatch } from './utils';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useSidebarOpenState } from '@backstage/core-components';

const useStyles = makeStyles(
  theme => ({
    item: {
      height: 48,
      width: '100%',
      '&:hover': {
        background:
          theme.palette.navigation.navItem?.hoverBackground || '#6f6f6f',
        color: theme.palette.navigation.selectedColor,
      },
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.navigation.color,
      cursor: 'pointer',
      position: 'relative',
      background: 'none',
      border: 'none',
      justifyContent:'flex-start',
      // padding:'20px 20px 20px 25px'
    },
    childItem:{
        height: 48,
      width: '100%',
      '&:hover': {
        background:
        theme.palette.navigation.navItem?.hoverBackground || '#6f6f6f',
        color: theme.palette.navigation.selectedColor,
      },
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.navigation.color,
      cursor: 'pointer',
      position: 'relative',
      background: 'none',
      border: 'none',
      justifyContent:'flex-start',
      padding:'20px 20px 20px 70px'
    },
    itemContainer: {
      width: '100%',
    },
    selected: {
      background: '#6f6f6f',
      color: theme.palette.common.white,
    },
    label: {
      margin: theme.spacing(1.75),
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.body2.fontSize,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 1,
      fontWeight:'bold',
      textTransform:'none',
      width:'70%',
      textAlign:'start'
    },
    subtitle: {
      fontSize: 10,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
    },
    dropdownArrow: {
      position: 'absolute',
      right: 21,
    },
    dropdown: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
    dropdownItem: {
      width: '100%',
      padding: '10px 0 10px 40px',
      '&:hover': {
        background:
          theme.palette.navigation.navItem?.hoverBackground || '#6f6f6f',
        color: theme.palette.navigation.selectedColor,
      },
    },
    selectedDropdownItem: {
        width: '100%',
        padding: '10px 0 10px 0',
        '&:hover': {
          background:
            theme.palette.navigation.navItem?.hoverBackground || '#6f6f6f',
          color: theme.palette.navigation.selectedColor,
        },
        // borderLeft:'3px solid #9BF0E1'
      },
    textContent: {
      color: theme.palette.navigation.color,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(1),
      fontSize: theme.typography.body2.fontSize,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
      display:'flex',
      fontWeight:'bold',
      
    },
  }),
  { name: 'BackstageSidebarSubmenuItem' },
);

/**
 * Clickable item displayed when submenu item is clicked.
 * title: Text content of item
 * to: Path to navigate to when item is clicked
 *
 * @public
 */
export type SidebarSubmenuItemDropdownItem = {
  title: string;
  to?: string;
  depth:number;
  children?:SidebarSubmenuItemDropdownItem[]
};

/**
 * Holds submenu item content.
 *
 * @remarks
 * title: Text content of submenu item
 * subtitle: A subtitle displayed under the main title
 * to: Path to navigate to when item is clicked
 * icon: Icon displayed on the left of text content
 * dropdownItems: Optional array of dropdown items displayed when submenu item is clicked.
 *
 * @public
 */
export type SidebarSubmenuItemProps = {
  title: string;
  subtitle?: string;
  to?: string;
  icon?: IconComponent;
  dropdownItems?: SidebarSubmenuItemDropdownItem[];
  exact?: boolean;
  initialShowDropdown?: boolean;
  isChild?:boolean
  depth:number
};

/**
 * Item used inside a submenu within the sidebar.
 *
 * @public
 */
export const SubMenuItem = (props: SidebarSubmenuItemProps) => {
  const { title, subtitle, to, icon: Icon, dropdownItems, exact,isChild,depth } = props;
  const classes = useStyles();
//   const { setIsHoveredOn } = useContext(SidebarItemWithSubmenuContext);
const [isHoveredOn,setIsHoveredOn]=useState(false)
  const closeSubmenu = () => {
    setSelectTab(true);
    setIsHoveredOn(false);
  };
  const [selectTab,setSelectTab]=useState('false');
  const { isOpen } = useSidebarOpenState();
  const toLocation = useResolvedPath(to ?? '');
  const currentLocation = useLocation();
  
  // let isActive = isLocationMatch(currentLocation, toLocation, exact);
  
  const [showDropDown, setShowDropDown] = useState(
    props.initialShowDropdown ?? false,
  );
  const handleClickDropdown = () => {
    setShowDropDown(!showDropDown);
  };

  // useEffect(()=>{
  //   if(!isOpen) setShowDropDown(false)
  // },[isOpen])

  const renderDropdownItems = (items: SidebarSubmenuItemDropdownItem[] | undefined) => {
    if (!items) return null;

    return items.map((item, index) => (
      <React.Fragment key={index}>
        {/* {currentLocation.pathname==='s3-buckets'?console.log('item'):null
        } */}
        {item.children ? (
          <SubMenuItem
            title={item.title}
            dropdownItems={item.children} 
            isChild = {true}
            depth={item.depth}
            to={item.to}
          />
        ) : (
          <Tooltip title={item.title} enterDelay={500} enterNextDelay={500}>
            <Link
              to={item.to}
              underline="none"
              className={classnames(
                classes.dropdownItem,
                currentLocation.pathname===item.to?classes.selected : undefined
                )}
              onClick={closeSubmenu}
              onTouchStart={e => e.stopPropagation()}
              style={{paddingLeft: item.depth ? (item.depth > 1 ? `${item.depth * 30}px` : `${item.depth * 40}px`) : '25px'}}
            >
              <Typography component="span" className={classes.textContent}>
                {item.title}
              </Typography>
            </Link>
          </Tooltip>
        )}
      </React.Fragment>
    ));
  };

  if (dropdownItems !== undefined) {

  return (
      <Box className={classes.itemContainer}>
        <Tooltip title={title} enterDelay={500} enterNextDelay={500}>
          {to? (
            <Link
              to={to}
              underline="none"
              className={classnames(classes.item,
                currentLocation.pathname===to?classes.selected : undefined
                )}
              // onClick={closeSubmenu}
              onTouchStart={e => e.stopPropagation()}
            >
             <Button
            role="button"
            onClick={handleClickDropdown}
            onTouchStart={e => e.stopPropagation()}
            className={classnames(
                isChild?classes.childItem:classes.item,
                currentLocation.pathname===to ? classes.selected : undefined,
            )}
            style={{paddingLeft:depth?depth>1?`${(depth * 40)+5}px`:`${depth * 70}px`:'25px'}}
          >
            {Icon && <Icon fontSize="small" />}
            <Typography
              variant="subtitle1"
              component="span"
              className={classnames(classes.label)}
            >
              {title}
              <br />
              {subtitle && (
                <Typography
                  variant="caption"
                  component="span"
                  className={classes.subtitle}
                >
                  {subtitle}
                </Typography>
              )}
            </Typography>
            {isOpen? (showDropDown ? (
              <ArrowDropUpIcon className={classes.dropdownArrow} />
            ) : (
              <ArrowDropDownIcon className={classes.dropdownArrow} />
            )):''}
          </Button>
          </Link>
          ) : (
            <Button
            role="button"
            onClick={handleClickDropdown}
            onTouchStart={e => e.stopPropagation()}
            className={classnames(
                isChild?classes.childItem:classes.item,
                currentLocation.pathname===to ? classes.selected : undefined,
            )}
            style={{paddingLeft:depth?depth>1?`${(depth * 40)+5}px`:`${depth * 70}px`:'25px'}}
          >
            {Icon && <Icon fontSize="small" />}
            <Typography
              variant="subtitle1"
              component="span"
              className={classnames(classes.label)}
            >
              {title}
              <br />
              {subtitle && (
                <Typography
                  variant="caption"
                  component="span"
                  className={classes.subtitle}
                >
                  {subtitle}
                </Typography>
              )}
            </Typography>
            {isOpen? (showDropDown ? (
              <ArrowDropUpIcon className={classes.dropdownArrow} />
            ) : (
              <ArrowDropDownIcon className={classes.dropdownArrow} />
            )):''}
          </Button>
          )}
        </Tooltip>
        {dropdownItems && showDropDown && (
          <Box className={classes.dropdown}>
              {renderDropdownItems(dropdownItems)}
          </Box>
        )}
      </Box>
    );
  }

};